import { render, staticRenderFns } from "./CustomerRetention.vue?vue&type=template&id=0b44acee"
import script from "./CustomerRetention.vue?vue&type=script&lang=js"
export * from "./CustomerRetention.vue?vue&type=script&lang=js"
import style0 from "./CustomerRetention.vue?vue&type=style&index=0&id=0b44acee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports